import { AREA_TOOLTIP_STYLE } from 'components/Map/NewJobMarkers/utils/markerConstants';
import { escapeHtml } from 'utils/security';
import { AREA_TYPES } from 'utils/territories/TerritoriesFromJson';

const getVehicleIdByTerritoryId = (vehicles, territoryId) =>
  vehicles?.find((v) => v.territories?.items?.some((item) => item.id === territoryId))?.id ?? null;

const buildTooltipContent = (properties, tourData, mapTranslations) => {
  const { type, name, groupName } = properties;
  const capitalType = type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
  const isConcave = type === AREA_TYPES.TOUR_HULL_CONCAVE;
  const isConvex = type === AREA_TYPES.TOUR_HULL_CONVEX;
  const isAvoid = type === AREA_TYPES.AVOID_AREA;
  const isExclude = type === AREA_TYPES.EXCLUDE_AREA;
  const isGroup = type === AREA_TYPES.GROUP;
  const vehicleId = getVehicleIdByTerritoryId(tourData?.fleet?.types, name);
  const safeName = escapeHtml(String(name ?? ''));

  const { tourJobMarkerTrans, groupMarkerTrans, avoidAreaTrans, excludeAreaTrans, territoryMarkerTrans } = mapTranslations;

  return [
    vehicleId ? `${tourJobMarkerTrans}: <b>${escapeHtml(String(vehicleId))}</b>` : null,
    groupName || isGroup
      ? `${groupMarkerTrans}: <b>${escapeHtml(String(isGroup ? name : groupName))}</b>`
      : null,
    isAvoid ? `${avoidAreaTrans}: <b>${safeName}</b>` : null,
    isExclude ? `${excludeAreaTrans}: <b>${safeName}</b>` : null,
    isConcave || isConvex ? `vehicleId: <b>${safeName}</b>` : null,
    !isConcave && !isConvex && !groupName && !isGroup && !isAvoid && !isExclude
      ? `${territoryMarkerTrans}: <b>${safeName} (${escapeHtml(capitalType)})</b>`
      : null,
  ]
    .filter(Boolean)
    .join('<br/>');
};

export const attachAreaEvents = (polygon, map, tourDataRef, translations, onClickFn) => {
  let tooltip = null;

  const removeTooltip = () => {
    if (tooltip) {
      tooltip.remove();
      tooltip = null;
    }
  };

  polygon.addEventListener('pointerenter', (evt) => {
    removeTooltip();
    const properties = polygon.getData();
    if (!properties) return;
    const mapTranslations = translations?.map;
    tooltip = document.createElement('div');
    Object.assign(tooltip.style, AREA_TOOLTIP_STYLE);
    tooltip.innerHTML = buildTooltipContent(properties, tourDataRef.current, mapTranslations);
    tooltip.style.left = `${evt.currentPointer.viewportX + 12}px`;
    tooltip.style.top = `${evt.currentPointer.viewportY - 10}px`;
    map.getElement().appendChild(tooltip);
  });

  polygon.addEventListener('pointermove', (evt) => {
    if (tooltip) {
      tooltip.style.left = `${evt.currentPointer.viewportX + 12}px`;
      tooltip.style.top = `${evt.currentPointer.viewportY - 10}px`;
    }
  });

  polygon.addEventListener('pointerleave', removeTooltip);

  if (onClickFn) {
    polygon.addEventListener('tap', () => {
      const properties = polygon.getData();
      if (properties) onClickFn(properties);
    });
  }
};
